"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var _ = __importStar(require("lodash"));
var dayjs_1 = __importDefault(require("dayjs"));
var AuthTable = function (_a) {
    var data = _a.data;
    return (react_1.default.createElement("div", { className: "auth-table table" },
        react_1.default.createElement("div", { className: "table__thead" },
            react_1.default.createElement("div", { className: "table__tr flex flex-row" },
                react_1.default.createElement("div", { className: "table__td" }, "Authorisation History"),
                react_1.default.createElement("div", { className: "table__td" }, "Authorised By"),
                react_1.default.createElement("div", { className: "table__td small" }, "Date"))),
        react_1.default.createElement("div", { className: "table__tbody" }, data.map(function (auth) { return (react_1.default.createElement("div", { className: "table__tr flex flex-row", key: auth.authoriser + "_" + auth.createdAt },
            react_1.default.createElement("div", { className: "table__td" },
                "Level ",
                auth.level),
            react_1.default.createElement("div", { className: "table__td" }, _.startCase(auth.authoriser)),
            react_1.default.createElement("div", { className: "table__td small" }, dayjs_1.default(auth.createdAt).format("DD/MM/YYYY")))); }))));
};
exports.default = AuthTable;
